import AbstractListResource from './abstract/abstract-list-resource';
import {Resource, ActionType} from 'sdk/src/defines';
import Subscriber from './items/subscriber';
import { DropDownItem } from '../utility/types';
import {TFunction} from 'react-i18next';

export enum SubscriberStatus {
    ACTIVE = 'active',
    DISABLED = 'disabled',
    DELETE = 'delete',
    DELETED = 'deleted',
    EMAIL_NOT_VERIFIED = 'emailNotVerified',
    PHONE_NOT_VERIFIED = 'phoneNotVerified',
}

class Subscribers extends AbstractListResource<Subscriber> {
    public resourceType: Resource = Resource.SUBSCRIBERS;

    public resourceItemClass: typeof Subscriber = Subscriber;

    public allowedActions: ActionType[] = [
        ActionType.LIST,
        ActionType.GET,
        ActionType.UPDATE,
        ActionType.DELETE,
        ActionType.CREATE,
    ];

    public statusesForDropDown(t: TFunction, empty?: string): DropDownItem[] {
        const result: DropDownItem[] = [];

        if (empty) {
            result.push({
                label: empty,
                value: undefined,
            });
        }

        result.push(
            {
                label: t('users.activeSubscribers'),
                value: SubscriberStatus.ACTIVE,
            },
            {
                label: t('users.disabledSubscribers'),
                value: SubscriberStatus.DISABLED
            },
            {
                label: t('users.waitingForTotallyRemoving'),
                value: SubscriberStatus.DELETE
            },
            {
                label: t('users.deletedSubscribers'),
                value: SubscriberStatus.DELETED,
            },
            {
                label: t('users.emailNotVerified'),
                value: SubscriberStatus.EMAIL_NOT_VERIFIED,
            },
            {
                label: t('users.phoneNotVerified'),
                value: SubscriberStatus.PHONE_NOT_VERIFIED,
            },
        );

        return result;
    }
}

export {Subscribers, Subscriber};

export default new Subscribers();
